import {
  CLEAR_TAGS,
  CLEAR_WAITLISTS,
  LOAD_APPOINTMENT_TYPES,
  LOAD_APPOINTMENT_TYPES_ERROR,
  LOAD_APPOINTMENT_TYPES_SUCCESS,
  LOAD_FACILITIES,
  LOAD_FACILITIES_ERROR,
  LOAD_FACILITIES_SUCCESS,
  LOAD_PROVIDERS,
  LOAD_PROVIDERS_ERROR,
  LOAD_PROVIDERS_SUCCESS,
  LOAD_TAGS,
  LOAD_TAGS_ERROR,
  LOAD_TAGS_SUCCESS,
  LOAD_WAITLISTS,
  LOAD_WAITLISTS_ERROR,
  LOAD_WAITLISTS_SUCCESS,
  SEND_OFFER,
  SEND_OFFER_ERROR,
  SEND_OFFER_SUCCESS,
} from './constants';

export const clearTags = () => ({
  type: CLEAR_TAGS,
});

export const clearWaitlists = () => ({
  type: CLEAR_WAITLISTS,
});

export const loadAppointmentTypes = () => ({
  type: LOAD_APPOINTMENT_TYPES,
});

export const loadAppointmentTypesError = (error) => ({
  type: LOAD_APPOINTMENT_TYPES_ERROR,
  error,
});

export const loadAppointmentTypesSuccess = (response) => ({
  type: LOAD_APPOINTMENT_TYPES_SUCCESS,
  response,
});

export const loadFacilities = (query) => ({
  type: LOAD_FACILITIES,
  query,
});

export const loadFacilitiesError = (error) => ({
  type: LOAD_FACILITIES_ERROR,
  error,
});

export const loadFacilitiesSuccess = (response) => ({
  type: LOAD_FACILITIES_SUCCESS,
  response,
});

export const loadTags = () => ({
  type: LOAD_TAGS,
});

export const loadTagsError = (error) => ({
  type: LOAD_TAGS_ERROR,
  error,
});

export const loadTagsSuccess = (response) => ({
  type: LOAD_TAGS_SUCCESS,
  response,
});

export const loadProviders = (query, initialValue) => ({
  type: LOAD_PROVIDERS,
  query,
  initialValue,
});

export const loadProvidersError = (error) => ({
  type: LOAD_PROVIDERS_ERROR,
  error,
});

export const loadProvidersSuccess = (response) => ({
  type: LOAD_PROVIDERS_SUCCESS,
  response,
});

export const loadWaitlists = (filters) => ({
  type: LOAD_WAITLISTS,
  filters,
});

export const loadWaitlistsError = (error) => ({
  type: LOAD_WAITLISTS_ERROR,
  error,
});

export const loadWaitlistsSuccess = (waitlists, patients, waitlistsGlobalCount, isBulkWaitlists, waitlistsQueryId) => ({
  type: LOAD_WAITLISTS_SUCCESS,
  waitlists,
  patients,
  waitlistsGlobalCount,
  isBulkWaitlists,
  waitlistsQueryId,
});

export const sendOffer = (offer, waitlists, waitlistsCount, waitlistsQueryId) => ({
  type: SEND_OFFER,
  offer,
  waitlists,
  waitlistsCount,
  waitlistsQueryId,
});

export const sendOfferError = (error) => ({
  type: SEND_OFFER_ERROR,
  error,
});

export const sendOfferSuccess = (response, notification) => ({
  type: SEND_OFFER_SUCCESS,
  response,
  notification,
});
